<template>
  <div v-if="artist">
    <section
      ref="profilesection"
      class="section mt-60 mb-60"
    >
      <div class="container">
        <div class="columns">
          <div
            class="column side-container"
            :class="isMobileView ? 'is-hidden' : 'is-one-quarter' "
          >
            <sidenav />
          </div>
          <div class="column is-three-quarter">
            <article class="is-profilebox is-mobile-profilebox">
              <div class="mobile-profilebox-container">
                <sidenav
                  id="mobile-sidenav"
                  :class="{ 'is-hidden': !isMobileView }"
                />
                <div
                  :class="{ 'is-mobile-profileDescription': isMobileView }"
                  class="content profileDescription"
                >
                  <div class="content profileDescription">
                    <span
                      v-if="artist.profile.description"
                      v-html="artist.profile.description"
                    />
                    <span v-else>{{ artist.nickname }} has not provided a description yet.</span>
                  </div>
                </div>
              </div>
            </article>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import sidenav from '~/components/sidenav'

const offsetOf = el => el.getBoundingClientRect().top

export default {
  layout: 'profile',

  components: {
    sidenav
  },

  data: () => ({}),

  computed: {
    ...mapState(['artist'])
  },

  // expose data to head of website
  // @note: error function returns 'undefined'!
  head() {
    return {
      title: this.artist.nickname,
      meta: [
        { name: 'robots', content: 'noindex' }
      ]
    }
  },

  async fetch({ store, params, error, app }) {
    store.commit('setProfileLoading', true)
    try {
      const cookie = app.context.req ? app.context.req.headers.cookie : null
      const data = await app.apiGet(
        `/api/public/user-profile/${params.id}`,
        null,
        cookie
      )

      store.commit('loadProfile', { artist: data.user, settings: {} })
    } catch (e) {
      console.log('There was an error while requesting data fron the API', e)
      error({ message: 'User not found', statusCode: 404 })
    } finally {
      store.commit('setProfileLoading', false)
    }
  },

  methods: {
    scrollHandler() {
      const mainnav = document.getElementById('mainnav')
      const area = this.$refs.profilesection
      if (area && mainnav) {
        const areaOffset = offsetOf(area)
        if (areaOffset <= 52) mainnav.classList.add('profile-is-sticky')
        if (areaOffset > 52) mainnav.classList.remove('profile-is-sticky')
        if (areaOffset <= 36) {
          mainnav.classList.add('light-shaded')
        }
        if (areaOffset > 36) {
          mainnav.classList.remove('light-shaded')
          if (window.scrollY > 5) {
            mainnav.classList.remove('dark-shaded')
          } else {
            mainnav.classList.add('dark-shaded')
          }
        }
      }
    }
  },

  mounted() {
    const mainnav = document.getElementById('mainnav')
    mainnav.classList.add('dark-shaded')
    window.addEventListener('scroll', this.scrollHandler)
  },

  destroyed() {
    window.removeEventListener('scroll', this.scrollHandler)
  }
}
</script>

<style lang="scss">
@import 'assets/sass/_variables';

.profileDescription blockquote:not(:last-child),
.profileDescription dl:not(:last-child),
.profileDescription ol:not(:last-child),
.profileDescription p:not(:last-child),
.profileDescription pre:not(:last-child),
.profileDescription table:not(:last-child),
.profileDescription ul:not(:last-child) {
  margin-bottom: 0;
}

.profilebox {
  border-radius: 0;
}
</style>
